import moment from 'moment';
import React from 'react';

const Footer = () => {
  const currentYear = () => {
    return moment().year();
  };

  return (
    <footer className="footer bg-white shadow align-self-end py-3 px-xl-5 w-100">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 text-center text-md-left text-primary">
            <p className="mb-2 mb-md-0">&copy; {currentYear()} Elite Nannies</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
